export default __webpack_public_path__ + "8dd8f987d6a1a65d1aa653125938ff4d.png";